import get from "lodash/get"

export const performanceTemplateTypeConfig = (report, templateType) => {
    switch (templateType) {
        case 1:
            return {
                planned_cycle_time: {
                    dataKey: "part_meta.cycle_time",
                    shiftDataKey: "shift_meta.planned_cycle_time",
                    daySummary: `${get(report, "template_meta.planned_cycle_time")
                        ? get(report, "template_meta.planned_cycle_time")
                        : "--"
                        } sec`,
                    suffix: "sec",
                    inHour: false,
                },
                actual_cycle_time: {
                    dataKey: "part_meta.avg_cycle_time",
                    shiftDataKey: "shift_meta.avg_cycle_time",
                    daySummary: `${get(report, "template_meta.avg_cycle_time")
                        ? get(report, "template_meta.avg_cycle_time")
                        : 0
                        } sec`,
                    suffix: "sec",
                    inHour: false,
                },
                production_count: {
                    dataKey: "counts",
                    shiftDataKey: "shift_meta.total_counts",
                    daySummary: `${get(report, "template_meta.total_count")
                        ? get(report, "template_meta.total_count")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
                planned_count: {
                    dataKey: "target_count",
                    shiftDataKey: "shift_meta.target_count",
                    daySummary: `${get(report, "template_meta.target_count")
                        ? get(report, "template_meta.target_count")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
                rejected_count: {
                    dataKey: "rejected_count",
                    shiftDataKey: "shift_meta_total_rejected_count",
                    daySummary: `${get(report, "template_meta.total_rejected_count")
                        ? get(report, "template_meta.total_rejected_count")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
                net_count: {
                    dataKey: "net_count",
                    shiftDataKey: "shift_meta.net_count",
                    daySummary: `${get(report, "template_meta.total_net_count")
                        ? get(report, "template_meta.total_net_count")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
            };
        case 2:
            return {
                production_length: {
                    dataKey: "length",
                    shiftDataKey: "shift_meta.total_length",
                    daySummary: `${get(report, "template_meta.total_length")
                        ? get(report, "template_meta.total_length")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
                planned_length: {
                    dataKey: "target_length",
                    shiftDataKey: "shift_meta.target_length",
                    daySummary: `${get(report, "template_meta.target_length")
                        ? get(report, "template_meta.target_length")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
                rejected_length: {
                    dataKey: "rejected_length",
                    shiftDataKey: "shift_meta.total_rejected_length",
                    daySummary: `${get(report, "template_meta.total_rejected_length")
                        ? get(report, "template_meta.total_rejected_length")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                    inHour: false,
                },
                net_length: {
                    dataKey: "net_length",
                    shiftDataKey: "shift_meta.net_length",
                    daySummary: `${get(report, "template_meta.total_net_length")
                        ? get(report, "template_meta.total_net_length")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
            }
        case 3:
            return {
                production_count: {
                    dataKey: "count",
                    shiftDataKey: "shift_meta.total_count",
                    daySummary: `${get(report, "template_meta.total_count")
                        ? get(report, "template_meta.total_count")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
                planned_count: {
                    dataKey: "target_count",
                    shiftDataKey: "shift_meta.target_count",
                    daySummary: `${get(report, "template_meta.target_count")
                        ? get(report, "template_meta.target_count")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
                rejected_count: {
                    dataKey: "rejected_count",
                    shiftDataKey: "shift_meta.total_rejected_count",
                    daySummary: `${get(report, "template_meta.total_rejected_count")
                        ? get(report, "template_meta.total_rejected_count")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
                net_count: {
                    dataKey: "net_count",
                    shiftDataKey: "shift_meta.net_count",
                    daySummary: `${get(report, "template_meta.total_net_count")
                        ? get(report, "template_meta.total_net_count")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
                      press_cycle:{
                    dataKey:"press_cycle",
                    shiftDataKey:"shift_meta.press_cycle",
                    daySummary:`${get(report,"template_meta.press_cycle")?get(report, "template_meta.press_cycle"):0}`,
                    suffix:""
                }
            };
        case 4:
            return {
                planned_cycle_time: {
                    dataKey: "part_meta.cycle_time",
                    shiftDataKey: "shift_meta.planned_cycle_time",
                    daySummary: `${get(report, "template_meta.planned_cycle_time")
                        ? get(report, "template_meta.planned_cycle_time")
                        : "--"
                        } sec`,
                    suffix: "sec",
                    inHour: false,
                },
                actual_cycle_time: {
                    dataKey: "part_meta.avg_cycle_time",
                    shiftDataKey: "shift_meta.avg_cycle_time",
                    daySummary: `${get(report, "template_meta.avg_cycle_time")
                        ? get(report, "template_meta.avg_cycle_time")
                        : 0
                        } sec`,
                    suffix: "sec",
                    inHour: false,
                },
                    machining_cycle: {
                    dataKey: "machining_cycle",
                    shiftDataKey: "shift_meta.machining_cycle",
                    daySummary: `${get(report, "template_meta.machining_cycle")
                        ? get(report, "template_meta.machining_cycle")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
                production_count: {
                    dataKey: "counts",
                    shiftDataKey: "shift_meta.total_counts",
                    daySummary: `${get(report, "template_meta.total_count")
                        ? get(report, "template_meta.total_count")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
               
                planned_count: {
                    dataKey: "target_count",
                    shiftDataKey: "shift_meta.target_count",
                    daySummary: `${get(report, "template_meta.target_count")
                        ? get(report, "template_meta.target_count")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
                rejected_count: {
                    dataKey: "rejected_count",
                    shiftDataKey: "shift_meta.total_rejected_count",
                    daySummary: `${get(report, "template_meta.total_rejected_count")
                        ? get(report, "template_meta.total_rejected_count")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
                net_count: {
                    dataKey: "net_count",
                    shiftDataKey: "shift_meta.net_count",
                    daySummary: `${get(report, "template_meta.total_net_count")
                        ? get(report, "template_meta.total_net_count")
                        : 0
                        }`,
                    suffix: "",
                    inHour: false,
                },
            };
    }
}

export const performanceTemplateDataSource = (templateType, config) => {
    switch (templateType) {
        case 1:
            return [
                {
                    key: "11",
                    category: "Cycle time",
                    basic: "Planned ",
                    ...get(config, "planned_cycle_time"),
                    rowSpan: 2,
                },
                {
                    key: "11.1",
                    category: "Cycle time",
                    basic: "Actual",
                    ...get(config, "actual_cycle_time"),
                },
                {
                    key: "12",
                    category: "Count",
                    basic: "Production",
                    ...get(config, "production_count"),
                    rowSpan: 4,
                },
                {
                    key: "13",
                    category: "Count",
                    basic: "Target",
                    ...get(config, "planned_count"),
                    rowSpan: 0,
                },
                {
                    key: "14",
                    category: "Count",
                    basic: "Rejection",
                    ...get(config, "rejected_count"),
                    rowSpan: 0,
                },
                {
                    key: "15",
                    category: "Count",
                    basic: "Net Production",
                    ...get(config, "net_count"),
                    rowSpan: 0,
                },
            ]
        case 2:
            return [
                {
                    key: "12",
                    category: "Length",
                    basic: "Production",
                    ...get(config, "production_length"),
                    rowSpan: 4,
                },
                {
                    key: "13",
                    category: "Length",
                    basic: "Target",
                    ...get(config, "planned_length"),
                    rowSpan: 0,
                },
                {
                    key: "14",
                    category: "Length",
                    basic: "Rejected Length",
                    ...get(config, "rejected_length"),
                    rowSpan: 0,
                },
                {
                    key: "15",
                    category: "Length",
                    basic: "Net Production",
                    ...get(config, "net_length"),
                    rowSpan: 0,
                },
            ]
        case 3:
            return [
                {
                    key: "12",
                    category: "Count",
                    basic: "Production",
                    ...get(config, "production_count"),
                    rowSpan: 5,
                },
                {
                    key: "13",
                    category: "Count",
                    basic: "Target",
                    ...get(config, "planned_count"),
                    rowSpan: 0,
                },
                {
                    key: "14",
                    category: "Count",
                    basic: "Rejection",
                    ...get(config, "rejected_count"),
                    rowSpan: 0,
                },
                {
                    key: "15",
                    category: "Count",
                    basic: "Net Production",
                    ...get(config, "net_count"),
                    rowSpan: 0,
                },
                   {
                    key: "16",
                    category:"Count",
                    basic:"Press Cycle",
                    ...get(config, "press_cycle"),
                    rowSpan:0
                }
            ]
        case 4:
            return [
                {
                    key: "11",
                    category: "Cycle time",
                    basic: "Planned ",
                    ...get(config, "planned_cycle_time"),
                    rowSpan: 2,
                },
                {
                    key: "11.1",
                    category: "Cycle time",
                    basic: "Actual",
                    ...get(config, "actual_cycle_time"),
                },    
              
                    {
                    key: "12",
                    category: "Count",
                    basic: "Machining cycle",
                    ...get(config, "machining_cycle"),
                    rowSpan: 5,
                },
                  {
                    key: "12",
                    category: "Count",
                    basic: "Production",
                    ...get(config, "production_count"),
                    rowSpan: 0,
                },
                {
                    key: "13",
                    category: "Count",
                    basic: "Target",
                    ...get(config, "planned_count"),
                    rowSpan: 0,
                },
                {
                    key: "14",
                    category: "Count",
                    basic: "Rejection",
                    ...get(config, "rejected_count"),
                    rowSpan: 0,
                },
                {
                    key: "15",
                    category: "Count",
                    basic: "Net Production",
                    ...get(config, "net_count"),
                    rowSpan: 0,
                },
            ]
    }
}